<template>
  <div class="searchWrap">
    <div class="search">
      <van-search
        v-model.trim="value"
        show-action
        :clearable="false"
        placeholder="请输入搜索关键词"
        @search="onSearch"
      >
        <template #action>
          <div @click="onClickButton">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="wrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="(item, index) in data" :key="index">
          <van-cell
            is-link
            v-if="type == 'department'"
            :title="item.departmentName"
            @click="handleSelect(item)"
          />
          <van-cell
            is-link
            v-if="type == 'cost'"
            :title="item.costName"
            @click="handleSelect(item)"
          />
          <van-cell
            is-link
            v-if="type == 'topEntourage'"
            :title="item.employeeName"
            @click="handleSelect(item)"
          />
          <van-cell
            is-link
            v-if="type == 'budgetUnit'"
            :title="item.budgetUnit"
            @click="handleSelect(item)"
          />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  computed: {
    type() {
      return this.$route.query.type;
    },
    isgetData(){
       return this.$route.query.isgetData
    },
    travelTypeCost(){
        return this.$route.query.travelTypeCost
    }
  },
  created() {
    this.getData();
  },
  beforeDestroy(){
    this.$bus.$off("searchSelect",()=>{})
  },
  data() {
    return {
      loading: false,
      finished: false,
      total: 0,
      value: "",
      data: [],
      searchForm: {
        pageNum: 1,
        pageRows: 20,
      },
    };
  },
  methods: {
    onLoad() {
      this.searchForm.pageRows += 10;
      this.getData();
    },
    onSearch(val) {
      this.searchForm.pageRows = 20;
      this.getData();
    },
    onClickButton() {
      this.searchForm.pageRows = 20;
      this.getData();
    },
    handleSelect(item) {
        this.$bus.$emit("searchSelect",item,this.type)
        this.$router.go(-1)
    },
    getData() {
      let path = "";
      let obj = {}
      if (this.type == "department") {
        path = "/payment/center/hoau/department/queryDepartment";
        obj.departmentName = this.value
      }
      if (this.type == "budgetUnit") {
        path = "/payment/center/hoau/budget/unit/getList";
        obj.budgetUnit = this.value
      }
      if (this.type == "cost") {
        path = "/payment/center/expense/cost/getHoauCostList";
        obj.costName = this.value
        obj.travelType = this.travelTypeCost || ""
        obj.companyId=Cookies.get("payapp_companyId")
        obj.workflow = this.$route.query.workflow
        // console.log(this.isgetData)
        if(this.isgetData != 1){
            return
        }
      }
      if(this.type == "topEntourage"){
        path = "/payment/center/hoau/employee/getEmployeeList"
        obj.employeeName  = this.value
      }
      this.$api
        .post(path, {
          reqData: {
            ...this.searchForm,
            ...obj
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.data = res.repData.list;
            this.total = res.repData.total;
            this.loading = false;
            if (this.total == this.data.length) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },
  },
};
</script>

<style lang="scss">
.searchWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
    overflow-y: auto;
  }
}
</style>